import { ReactNode } from 'react';
import AppBar from './AppBar';
import { EmbedButton } from './EmbedButton';
import { useSearchParams } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === 'true';

  return (
    <div className="fixed inset-0 flex flex-col bg-gray-50 dark:bg-gray-900 overflow-hidden">
      {/* App Bar */}
      {!isEmbed && <AppBar />}

      {/* Main Content */}
      <div className="flex-1 flex overflow-auto">
        {children}
      </div>

      {/* Embed Button */}
      {isEmbed && <EmbedButton />}
    </div>
  );
}

export default Layout;
